import type {AddMgtFormDataType} from '../components/Container/Presenter/Progress/ProgressMgtCreateDrawer';

export const validateProgressAddMgtForm = (
  data: AddMgtFormDataType,
  existingCompanyIds: number[] = [],
): {
  isValid: boolean;
  errors: Partial<Record<keyof AddMgtFormDataType, string>>;
} => {
  const errors: Partial<Record<keyof AddMgtFormDataType, string>> = {};

  // 会社名のバリデーション
  if (!data.companyName.trim()) {
    errors.companyName = '会社名を入力してください';
  }

  // 既存のcompanyIdとの重複チェック
  if (data.companyId && existingCompanyIds.includes(data.companyId)) {
    errors.companyName =
      'この企業は既に登録されています。別の企業を選択してください';
  }

  // 選考予定のバリデーション
  if (!data.stepName.trim()) {
    errors.stepName = '選考予定を入力してください';
  }

  // 日付の妥当性チェック
  if (data.startDate && data.endDate) {
    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);
    if (startDate > endDate) {
      errors.endDate = '終了日時は開始日時以降の日時を入力してください';
    }
  }

  const isValid = Object.keys(errors).length === 0;

  return {isValid, errors};
};
